<div class="container-fluid">
  <div class="page-head">
    <h5 class="header-title heading-color">VIEW PHYSICIAN</h5>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <div class="card m-b-30">
        <form [formGroup]="physicianForm">
          <div class="card-body">
            <!--SEARCH PHYSICIAN BY ID OR EMAIL-->
            <div class="row">
              <div class="col-12">
                <h6 class="text-center">ENTER PHYSICIAN NAME OR EMAIL</h6>
              </div>
            </div>
            <br />

            <div class="row">
              <div class="col-lg-3 col-md-3"></div>

              <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <input
                  type="text"
                  formControlName="phy_name"
                  class="form-control select"
                  placeholder="Physician Name"
                />
              </div>

              <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <input
                  type="email"
                  placeholder="Mail ID"
                  formControlName="email_id"
                  class="form-control select"
                />
                <span
                  *ngIf="physicianForm.get('email_id').hasError('pattern')"
                  class="invalid-feedback"
                >
                  Email is invalid
                </span>
              </div>

              <div class="col-lg-3 col-md-3"></div>
            </div>
            <br /><br />
            <div class="row">
              <div class="col-12 text-center">
                <button
                  type="submit"
                  name="find"
                  class="btn btn-primary text-white btn-rounded"
                  (click)="findPhysician(1)"
                >
                  FIND PHYSICIAN
                </button>
              </div>
              <!-- download excel -->
              <div class="d-flex" *ngIf="physicians && physicians.length > 0">
                <div class="pl-0 pr-0 align-items-center pull-right mt-3 ml-5">
                  <p class="font-weight-100">
                    <button (click)="exportAsXLSX()">
                      <i
                        class="fa fa-file-excel-o mr-1"
                        style="font-size: 23px; color: blue"
                      ></i>
                    </button>
                  </p>
                </div>
                <div class="pl-0 pr-0 ml-2 pull-right mt-4">
                  <label class="font-weight-bold">Click Icon to Download</label>
                </div>
              </div>
              <!-- download excel -->
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<!--END OF SEARCH PHYSICIAN BY ID OR EMAIL-->
<!--START OF PHYSICIAN TABLE-->
<div class="container-fluid" *ngIf="physicians?.length">
  <div class="row">
    <div class="col-lg-12">
      <div class="card m-b-30">
        <div class="card-body table-responsive">
          <div class="col-md-12 detail-tbl">
            <table class="table">
              <thead>
                <tr>
                  <th
                    scope="col"
                    class="text-center"
                    style="vertical-align: middle"
                  >
                    TITLE
                  </th>
                  <th
                    scope="col"
                    class="th-item text-center"
                    style="vertical-align: middle"
                  >
                    FIRST NAME
                  </th>
                  <th scope="col" class="th-item text-center">LAST NAME</th>
                  <th scope="col" class="th-item text-center">ID</th>
                  <th scope="col" class="th-item text-center">EMAIL ID</th>
                  <th scope="col" class="th-item text-center">
                    Payout Percentage
                  </th>
                  <th scope="col" class="th-item">FEE</th>
                  <th scope="col" class="th-item text-center">Follow-Up Fee</th>
                  <th scope="col" class="th-item text-center">
                    ENABLE PAID FEATURE
                  </th>
                  <th scope="col" class="th-item text-center">ACTIVATE</th>
                  <th scope="col" class="th-item text-center">VERIFY</th>
                  <th scope="col" class="th-item text-center">DETAILS</th>
                </tr>
              </thead>
              <tr *ngFor="let p of physicians; let i = index">
                <td class="font-size-15 text-color align-middle">
                  {{ p?.title }}
                </td>
                <td class="font-size-15 text-color align-middle">
                  {{ p?.first_name }}
                </td>
                <td class="font-size-15 text-color align-middle">
                  {{ p?.last_name }}
                </td>
                <td class="font-size-15 text-color align-middle">
                  {{ p?.u_id }}
                </td>
                <td class="font-size-15 text-color align-middle">
                  {{ p?.email_id }}
                </td>
                <!-- <td class="font-size-15 text-color">{{p?.u_id}}</td> -->
                <td class="font-size-15 text-coloralign-middle">
                  <input
                    type="number"
                    pattern="^[0-9]+$"
                    max="100"
                    min="0"
                    class="form-control select"
                    [value]="convertStringToFloat(p?.consultation_share) * 100"
                    (blur)="consultationShareChange(i, $event)"
                    required
                  />
                </td>
                <td class="font-size-15 text-color align-middle">
                  {{
                    p?.physician_consultfee &&
                    p?.physician_consultfee?.length > 0 &&
                    p?.physician_consultfee[0]?.fee
                      ? p?.physician_consultfee[0]?.fee
                      : "Not Added"
                  }}
                </td>
                <td class="font-size-15 text-color align-middle">
                  {{
                    p?.physician_consultfee &&
                    p?.physician_consultfee?.length > 0 &&
                    p?.physician_consultfee[0]?.followup_fee
                      ? p?.physician_consultfee[0]?.followup_fee
                      : "Not Added"
                  }}
                </td>
                <td class="align-middle">
                  <span class="custom-control custom-switch d-inline-block">
                    <input
                      type="checkbox"
                      class="custom-control-input cursor"
                      [checked]="p?.paid_account"
                      (change)="paidAccStatusChange(i, p?.paid_account)"
                      [id]="i"
                    />
                    <label
                      class="custom-control-label cursor"
                      [for]="i"
                    ></label>
                  </span>
                </td>
                <td class="align-middle">
                  <!-- Changes included for Superadmin role enhancements START -->
                  <span class="custom-control custom-switch d-inline-block">
                    <input
                      type="checkbox"
                      class="custom-control-input cursor"
                      [checked]="p?.ac_status"
                      (change)="onAccStatusChange(i, p?.ac_status)"
                      [id]="'status' + i"
                    />
                    <label
                      class="custom-control-label cursor"
                      [for]="'status' + i"
                    ></label>
                  </span>

                  <!--<div class="d-flex">
                    <div class="tabledit-toolbar btn-toolbar" *ngIf="!p?.ac_status">
                      <button type="button" class="btn btn-primary btn-model"
                        (click)="onAccStatusChange(i, p?.ac_status)">Activate</button>
                    </div>
                    <div *ngIf="p?.ac_status" class="font-size-15 text-color">
                      <label> Active</label>
                    </div>
                  </div>-->
                  <!-- Changes included for Superadmin role enhancements END -->
                </td>

                <td class="align-middle">
                  <!-- Changes included for Superadmin role enhancements START -->
                  <span class="custom-control custom-switch d-inline-block">
                    <input
                      type="checkbox"
                      class="custom-control-input cursor"
                      [checked]="p?.verified"
                      (change)="checkRequestNew(i, p?.verified)"
                      [id]="'verify' + i"
                    />
                    <label
                      class="custom-control-label cursor"
                      [for]="'verify' + i"
                    ></label>
                  </span>
                  <!--<div class="d-flex">

                    <div class="tabledit-toolbar btn-toolbar" *ngIf="!p?.verified">
                      <button type="button" class="btn btn-primary btn-model"
                        (click)="checkRequest(i, p?.verified, true)">Verify</button>
                    </div>
                    <div *ngIf="p?.verified" class="font-size-15 text-color">
                      <label> Verified</label>
                    </div>
                  </div>-->
                  <!-- Changes included for Superadmin role enhancements END -->
                </td>

                <!-- Changes included for Superadmin role enhancements START -->
                <td class="align-middle">
                  <div class="d-flex">
                    <button
                      type="button"
                      class="btn btn-primary btn-model"
                      [routerLink]="['/superadmin/phy-detail/' + p.u_id]"
                    >
                      View Details
                    </button>
                  </div>
                </td>
                <!-- Changes included for Superadmin role enhancements END -->
              </tr>
              <tbody>
                <tr></tr>
              </tbody>
            </table>
          </div>
          <div class="row">
            <div class="col-md-12 mt-2">
              <div class="d-flex">
                <div class="form-group d-flex mb-0 mr-2">
                  <select
                    class="form-control"
                    [(ngModel)]="pagesize"
                    id="pagesize"
                    (change)="pageChanged()"
                  >
                    <option *ngFor="let c of pageCount" value="{{ c }}">
                      {{ c }}
                    </option>
                  </select>
                </div>
                <ngb-pagination
                  [collectionSize]="collectionSize"
                  [(page)]="page"
                  [maxSize]="5"
                  [pageSize]="pagesize"
                  [rotate]="true"
                  [boundaryLinks]="true"
                  (pageChange)="pageChanged()"
                ></ngb-pagination>
                <div class="ml-2 line-h-36">
                  Total rows : {{ collectionSize }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid" *ngIf="noPhysician">
  <div class="card m-b-30">
    <div class="card-body table-responsive">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h5 class="text-danger">No Physician Found</h5>
        </div>
      </div>
    </div>
  </div>
</div>
